import { ComponentsProps, ComponentsOverrides, ComponentsVariants } from '@mui/material';
import { Theme } from '@mui/material';

export const TooltipTheme = (): {
  defaultProps?: ComponentsProps['MuiTooltip'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTooltip'];
  variants?: ComponentsVariants['MuiTooltip'];
} => {
  return {
    styleOverrides: {
      tooltip: {
        backgroundColor: 'black',
        color: 'white',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        fontSize: '0.85rem',
        borderRadius: '4px',
        padding: '8px',
        lineHeight: 1.2
      },
      arrow: {
        color: 'black'
      }
    }
  };
};
